import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IFilterParams, IPackagesUnitsLogsItem } from '../../interfaces';

export function usePaperTrailLogsTable(): IPackagesUnitsLogsItem[] {
    return useContext(MobXProviderContext).RootStore.paperTrailLogsStore.list;
}

export function usePaperTrailLogsFilterParams(): IFilterParams {
    return useContext(MobXProviderContext).RootStore.paperTrailLogsStore.filterParams;
}
